<template>
    <portal to="modal" v-if="show">
        <div class="MyPosModal" ref="modalContainer" :class="{ isActive: show }">
            <div class="MyPosModal-Backdrop" @click="closeModal" ref="backdrop" />

            <div class="MyPosModal-Content" ref="content">
                <!-- Close Button -->
                <button class="MyPosModal-Close" @click="closeModal" type="button">
                    <i class="ri-close-line"></i>
                </button>

                <div class="MyPosModal-Scrollable">
                    <div class="mypos-modal-content special-offer">
                        <div class="offer-badge">
                            <i class="ri-time-line"></i>
                            <span>EXKLUSIVER PARTNER</span>
                        </div>

                        <div class="offer-content">
                            <div class="offer-info">
                                <div class="partner-logo">
                                    <img src="/partners/mypos.png" alt="MyPos" />
                                    <span class="partner-label">Unser Partner</span>
                                </div>
                                <div class="offer-description">
                                    <p class="promo-description">
                                        Als TaxiFusion Partner erhalten Sie das myPOS Go 2 Terminal
                                        für nur 9€. Profitieren Sie von günstigen
                                        Transaktionsgebühren und nahtloser Integration mit
                                        TaxiFusion.
                                    </p>
                                    <div class="promo-benefits">
                                        <div class="benefit-item">
                                            <i class="ri-check-line"></i>
                                            <span>myPOS Go 2 Terminal für nur 9€</span>
                                        </div>
                                        <div class="benefit-item">
                                            <i class="ri-check-line"></i>
                                            <span>Bis zu 2 Geräte je Auto</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="process-steps">
                                    <h4>So funktioniert's:</h4>
                                    <div class="step">
                                        <div class="step-number">1</div>
                                        <div class="step-content">
                                            <strong>Registrierung bei MyPos</strong>
                                            <p>
                                                Klicken Sie auf "Jetzt bei MyPos registrieren" und
                                                achten Sie darauf, dass Sie über unseren
                                                Partner-Link registrieren.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="step">
                                        <div class="step-number">2</div>
                                        <div class="step-content">
                                            <strong>Bei uns melden</strong>
                                            <p>
                                                Melden Sie sich nach der Registrierung bei uns,
                                                damit wir die Verbindung herstellen können.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="step">
                                        <div class="step-number">3</div>
                                        <div class="step-content">
                                            <strong>Terminal erhalten</strong>
                                            <p>
                                                Sie erhalten bis zu 2 Geräte je Auto. Abholung oder
                                                Versand möglich (Versandkosten werden berechnet).
                                            </p>
                                        </div>
                                    </div>
                                    <div class="step">
                                        <div class="step-number">4</div>
                                        <div class="step-content">
                                            <strong>MyPos mit TaxiFusion verbinden</strong>
                                            <p>
                                                Gehen Sie in Ihre
                                                <router-link
                                                    to="/settings"
                                                    class="settings-link"
                                                    @click.native="closeModal"
                                                    >Einstellungen</router-link
                                                >
                                                und verbinden Sie MyPos mit TaxiFusion.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="product-image">
                                <img src="/partners/myPOS-GO2.webp" alt="MyPos Go2 Terminal" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="MyPosModal-Actions">
                    <Button variant="basic" @onClick="closeModal">Schließen</Button>
                    <Button @onClick="handleMyPosRedirect" :isLoading="isLoading">
                        Jetzt bei MyPos registrieren
                        <template #iconAfter>
                            <i class="ri-external-link-line"></i>
                        </template>
                    </Button>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import { gsap } from 'gsap';
import Button from '@/components/widgets/Button';

export default {
    name: 'MyPosModal',
    components: {
        Button,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
                this.$nextTick(() => {
                    this.animateIn();
                });
            } else {
                this.animateOut();
            }
        },
    },
    methods: {
        animateIn() {
            const tl = gsap.timeline({
                defaults: {
                    ease: 'power3.out',
                    force3D: true,
                    transformOrigin: 'center center',
                },
            });

            tl.fromTo(
                this.$refs.backdrop,
                { autoAlpha: 0 },
                {
                    autoAlpha: 1,
                    duration: 0.5,
                    ease: 'power2.inOut',
                    force3D: true,
                },
            )
                .fromTo(
                    this.$refs.content,
                    {
                        y: 60,
                        scale: 0.9,
                        autoAlpha: 0,
                        rotationX: 5,
                        transformOrigin: 'center center',
                    },
                    {
                        y: 0,
                        scale: 1,
                        autoAlpha: 1,
                        rotationX: 0,
                        duration: 0.6,
                        ease: 'back.out(1.7)',
                        force3D: true,
                    },
                    '-=0.4',
                )
                .from(
                    '.mypos-modal-content',
                    {
                        y: 30,
                        autoAlpha: 0,
                        duration: 0.7,
                        ease: 'power2.out',
                        force3D: true,
                    },
                    '-=0.3',
                );
        },
        animateOut() {
            const tl = gsap.timeline({
                defaults: {
                    ease: 'power3.in',
                    force3D: true,
                },
            });

            tl.to(this.$refs.content, {
                y: -30,
                scale: 0.95,
                autoAlpha: 0,
                duration: 0.4,
                ease: 'power2.in',
                force3D: true,
            })
                .to(
                    this.$refs.backdrop,
                    {
                        autoAlpha: 0,
                        duration: 0.3,
                        ease: 'power2.in',
                        force3D: true,
                    },
                    '-=0.2',
                )
                .to(
                    this.$refs.modalContainer,
                    {
                        autoAlpha: 0,
                        duration: 0.2,
                        ease: 'power2.in',
                        force3D: true,
                        onComplete: () => {
                            this.isActive = false;
                            document.body.style.overflow = '';
                            this.$emit('onClose');
                        },
                    },
                    '-=0.1',
                );
        },
        closeModal() {
            this.animateOut();
        },
        handleMyPosRedirect() {
            window.open(
                'https://www.mypos.eu/de/enroll/ref:1007477',
                '_blank',
                'noopener,noreferrer',
            );
            this.closeModal();
        },
    },
    beforeDestroy() {
        document.body.style.overflow = '';
    },
};
</script>

<style lang="scss" scoped>
:root {
    --modal-ease-out: cubic-bezier(0.4, 0, 0.2, 1);
    --modal-ease-in: cubic-bezier(0.4, 0, 1, 1);
    --modal-ease-bounce: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.MyPosModal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    visibility: visible;
    opacity: 1;
    will-change: opacity, transform;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    @media screen and (max-width: $breakpoint-tablet-portrait) {
        padding: 10px;
    }

    &.isActive {
        opacity: 1;
        visibility: visible;
    }

    .MyPosModal-Backdrop {
        background-color: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        will-change: opacity;
        transform: translateZ(0);
        -webkit-backdrop-filter: blur(4px);
    }

    .MyPosModal-Content {
        z-index: 1;
        background: white;
        max-width: 900px;
        max-height: 90vh;
        width: 100%;
        position: relative;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        border: 0.5px solid rgba(0, 0, 0, 0.05);
        overflow: hidden;
        will-change: transform, opacity;
        transform: translateZ(0);
        backface-visibility: hidden;
        -webkit-overflow-scrolling: touch;

        @media screen and (max-width: $breakpoint-tablet-portrait) {
            max-height: 95vh;
            border-radius: 12px;
        }
    }

    .MyPosModal-Close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        border: none;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        color: #666;
        will-change: transform, background-color;
        transform: translateZ(0);

        &:hover {
            background: rgba(0, 0, 0, 0.2);
            color: #333;
            transform: translateZ(0) scale(1.1);
        }

        i {
            font-size: 20px;
        }

        @media screen and (max-width: $breakpoint-tablet-portrait) {
            top: 15px;
            right: 15px;
            width: 35px;
            height: 35px;

            i {
                font-size: 18px;
            }
        }
    }

    .MyPosModal-Scrollable {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        will-change: scroll-position;
        transform: translateZ(0);
    }

    .mypos-modal-content.special-offer {
        padding: 0;
        margin: 0;
        background: linear-gradient(135deg, white 50%, #ffccad);
        position: relative;
        will-change: transform;
        transform: translateZ(0);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        .offer-badge {
            position: absolute;
            top: 60px;
            right: 15px;
            background: #ef4444;
            padding: 8px 18px 8px 12px;
            border-radius: 30px;
            font-size: 0.75rem;
            font-weight: 700;
            color: white;
            display: flex;
            align-items: center;
            gap: 5px;
            box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3);

            i {
                font-size: 20px;
            }

            span {
                font-weight: 800;
                margin-right: 5px;
            }

            @media screen and (max-width: $breakpoint-tablet-portrait) {
                display: none;
                position: relative;
                width: calc(100% - 20px);
                left: 0;
                top: 30px;
                margin: 0 auto;
                border-radius: 16px;
                justify-content: center;
            }
        }

        .offer-content {
            display: flex;
            padding: 50px;
            align-items: center;
            gap: 40px;

            @media screen and (max-width: $breakpoint-tablet-landscape) {
                flex-direction: column-reverse;
                padding: 40px 20px;
                text-align: center;
            }
        }

        .offer-info {
            flex: 1;

            .partner-logo {
                margin-bottom: 25px;
                display: flex;
                align-items: center;
                gap: 10px;

                img {
                    height: 60px;
                }

                .partner-label {
                    background: rgba(59, 130, 246, 0.1);
                    color: #1e40af;
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    border: 0.5px solid rgba(59, 130, 246, 0.2);
                }
            }

            .offer-description {
                margin-bottom: 30px;

                .promo-description {
                    color: #4b5563;
                    font-size: 1.1rem;
                    line-height: 1.6;
                    margin-bottom: 20px;
                }
            }
        }

        .process-steps {
            margin-top: 30px;

            h4 {
                color: #374151;
                margin-bottom: 20px;
                font-size: 1.1rem;
                font-weight: 700;
            }

            .step {
                display: flex;
                align-items: flex-start;
                gap: 15px;
                margin-bottom: 20px;

                .step-number {
                    background: #3b82f6;
                    color: white;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 0.9rem;
                    flex-shrink: 0;
                }

                .step-content {
                    flex: 1;

                    strong {
                        color: #374151;
                        font-size: 1rem;
                        display: block;
                        margin-bottom: 5px;
                    }

                    p {
                        color: rgb(58, 58, 58);
                        font-size: 0.9rem;
                        line-height: 1.5;
                        margin: 0;

                        .settings-link {
                            color: rgb(2, 54, 138);
                            font-weight: 600;
                            text-decoration: underline;
                            background: rgba(59, 130, 246, 0.1);
                            padding: 2px 8px;
                            border-radius: 4px;
                            border: 0.5px solid rgba(59, 130, 246, 0.2);
                            transition: all 0.2s ease;

                            &:hover {
                                background: rgba(59, 130, 246, 0.2);
                                color: #1e40af;
                            }
                        }
                    }
                }
            }
        }

        .promo-benefits {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .benefit-item {
                display: flex;
                align-items: center;
                gap: 8px;
                background: rgba(251, 191, 36, 0.15);
                border: 0.5px solid var(--color-warning);
                padding: 8px 15px;
                border-radius: 50px;

                @media screen and (max-width: $breakpoint-tablet-landscape) {
                    justify-content: center;
                    width: 100%;
                }

                i {
                    color: #7c2d12;
                    font-size: 16px;
                }

                span {
                    font-weight: 600;
                    color: #7c2d12;
                    font-size: 0.9rem;
                }
            }
        }

        .product-image {
            flex: 1;
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            position: relative;
            will-change: transform;
            transform: translateZ(0);

            img {
                max-height: 300px;
                filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.15));
                transform: perspective(800px) rotateY(-15deg) rotateX(5deg) rotate(5deg);
                transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
                will-change: transform;
                backface-visibility: hidden;
                -webkit-font-smoothing: antialiased;

                &:hover {
                    transform: perspective(800px) rotateY(0deg) rotateX(0deg) rotate(0deg)
                        scale(1.1);
                }

                @media screen and (max-width: $breakpoint-tablet-landscape) {
                    max-width: 280px;
                    transform: none;
                    margin-bottom: 20px;
                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }
        }
    }

    .MyPosModal-Actions {
        padding: 30px 40px;
        display: flex;
        gap: 15px;
        justify-content: flex-end;
        border-top: 0.5px solid rgba(0, 0, 0, 0.08);
        background: rgba(0, 0, 0, 0.02);
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 5;
        will-change: transform;
        transform: translateZ(0);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);

        @media screen and (max-width: $breakpoint-tablet-portrait) {
            padding: 20px;
            flex-direction: column-reverse;
        }

        .Button {
            min-width: 120px;

            @media screen and (max-width: $breakpoint-tablet-portrait) {
                width: 100%;
            }
        }
    }
}
</style>
